<div class="container-fluid">
  <div class="row">
    <ng-template #sidebarOffcanvas let-offcanvas>
      <div class="offcanvas-header">
        <h6 class="offcanvas-title text-muted" id="offcanvas-basic-title" ngbAutofocus>
          ระบบตรวจสอบและติดตามการประมวลผล <br>
          SRM Process
        </h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
      </div>
      <div class="offcanvas-body">
        <div id="sidebar-offcanvas">
          <div tabindex="-1" aria-labelledby="sidebar-menu-label">
            <div class="flex-column">
              <ng-container [ngTemplateOutlet]="sidebar"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isSidebarCollapsed" [horizontal]="true" class="col-auto p-0">
      <div id="sidebar">
        <div id="sidebar-menu" tabindex="-1" aria-labelledby="sidebar-menu-label">
          <div class="flex-column">
            <ng-container [ngTemplateOutlet]="sidebar"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col overflow-y-auto p-0">
      <header id="header" class="sticky-top w-100 position-relative">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid">
            @if (toggleOffCanvas) {
              <button class="navbar-toggler d-block border-0 rounded px-1" type="button"
                      (click)="openSidebarOffcanvas(sidebarOffcanvas)">
                <i class="bi bi-layout-sidebar text-white fs-3"></i>
              </button>
            } @else {
              <button class="navbar-toggler d-block border-0 rounded px-1" type="button"
                      [attr.aria-expanded]="!isSidebarCollapsed"
                      (click)="collapse.toggle()">
                <i class="bi bi-layout-sidebar text-white fs-3"></i>
              </button>
            }
            <div class="collapse navbar-collapse ms-3" id="navbarSupportedContent">
              <ul id="select-font-size" class="navbar-nav me-auto mb-lg-0">
                <li class="nav-item me-1" (click)="setFontSizeTo('14px')">
                  <input type="radio" class="btn-check" name="options" id="fs14px" [value]="'14px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs14px">ก</label>
                </li>
                <li class="nav-item me-1" (click)="setFontSizeTo('16px')">
                  <input type="radio" class="btn-check" name="options" id="fs16px" [value]="'16px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs16px">ก+</label>
                </li>
                <li class="nav-item me-1" (click)="setFontSizeTo('18px')">
                  <input type="radio" class="btn-check" name="options" id="fs18px" [value]="'18px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs18px">ก++</label>
                </li>
              </ul>
              <div class="dropdown flex-row text-end me-1">
                <a role="button" class="d-block text-decoration-none dropdown-toggle"
                   style="font-size: 12.5px" data-bs-toggle="dropdown" aria-expanded="false">
                  {{ principal?.name }} <br>
                  <small style="font-size: 0.8rem">{{ principal?.organization?.id }}
                    - {{ principal?.organization?.name }}</small>
                </a>
                <ul class="dropdown-menu dropdown-menu-start text-small" style="right: 0;">
                  <li class="cursor-pointer"><a (click)="profile()" class="dropdown-item"><i
                    class="bi bi-person me-2"></i>โปรไฟล์</a></li>
                  <li class="cursor-pointer"><a (click)="logout()" class="dropdown-item"><i
                    class="bi bi-box-arrow-in-right me-2"></i>ออกจากระบบ</a>
                  </li>
                </ul>
              </div>

              <ul class="navbar-nav flex-row d-md-none">
                <li class="nav-item text-nowrap">
                  <button class="nav-link px-3"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#sidebar-menu" aria-controls="sidebar-menu" aria-expanded="false"
                          aria-label="Toggle navigation">
                    <span class="bi bi-list"></span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <div id="content">
        <div class="ps-3 pt-3 pe-3 pb-5 mb-5">
          @if (isTestEnv()) {
            <ngb-alert type="custom" class="text-center fw-semibold fixed-bottom">
              ขณะนี้คุณกำลังใช้งานบน TEST ZONE สปสช.
              <div class="marquee">
                <div class="overlay">
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                </div>
              </div>
            </ngb-alert>
          }
          <app-loading></app-loading>
          <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
          <app-header></app-header>
          <router-outlet/>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #sidebar>
  @if (!toggleOffCanvas) {
    <ul class="nav flex-column sticky-top" style="min-height:51px; border-bottom: 1px solid #e9ecef;">
      <li class="nav-item d-flex p-2">
        <a class="navbar-brand d-none d-md-flex">
          <img src="/assets/images/nhso-minimize.webp" alt="Logo" class="">
          <div class="">
            ระบบตรวจสอบและติดตามการประมวลผล <br>
            SRM Process
          </div>
        </a>
      </li>
    </ul>
  }
  <div id="sidebar-content">
    <ul class="nav flex-column mt-3">
      <li class="nav-item">
        <a class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
           href="{{environment.srmPortalUrl}}">
          <i class="bi bi-grid-fill"></i>
          ไปที่ Portal
        </a>
      </li>
    </ul>
    <ul class="nav flex-column">
      <li class="nav-item">
        <a routerLink="/secure/processing/daily"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-calendar-check-fill"></i>
          ตรวจสอบประมวลผลรายวัน
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/secure/processing/schedule"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-calendar-date-fill"></i>
          ตรวจสอบเวลาทำงานราย Schedule
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/secure/processing/schedule-log"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-shuffle"></i>
          รายงานการประมวลผลทั้งหมด
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/secure/processing/tracking"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-stopwatch-fill"></i>
          ประมวลผล Manual และติดตามสถานะ
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/secure/import/import-file-result"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-upload"></i>
          นำเข้าไฟล์
        </a>
      </li>
    </ul>
    <ul class="nav flex-column">
      <li class="nav-item">
        <a routerLink="/secure/lk2-token"
           routerLinkActive="active"
           class="nav-link btn btn-toggle d-flex text-start align-middle rounded border-0 gap-2">
          <i class="bi bi-key-fill"></i>
          LK2 Token
        </a>
      </li>
    </ul>
  </div>
</ng-template>
